module.exports = __webpack_public_path__ + "img/55ffa86.png";